import React from 'react';
import Actualites from 'components/actualites/actualites';
import Header from 'components/common/header/header';

class ActualitesPage extends React.Component<{ setHeaderValues: Function }> {

  componentDidMount() {
    this.props.setHeaderValues({ headerUrl: 'actualites', headerTitle: undefined, headerPictureUrl: undefined })
  }

  render() {
    return (
      <div>
        <Actualites limit={false} />
      </div>
    );
  }

}

export default ActualitesPage;
